import React, { memo } from 'react';

import DonutChart, { DonutChartProps } from '.';
import {
	StyledDonutChartWithTextColor,
	StyledDonutChartWithTextList,
	StyledDonutChartWithTextListItem,
	StyledDonutChartWithTextWrap,
} from './style';

interface PropsType extends DonutChartProps {}

function DonutChartWithText({ segments, ...props }: PropsType) {
	return (
		<StyledDonutChartWithTextWrap>
			<DonutChart segments={segments} {...props} />
			<StyledDonutChartWithTextList>
				{segments?.map((segment) => (
					<StyledDonutChartWithTextListItem key={segment.label}>
						<StyledDonutChartWithTextColor background={segment.color} /> {segment.label}
					</StyledDonutChartWithTextListItem>
				))}
			</StyledDonutChartWithTextList>
		</StyledDonutChartWithTextWrap>
	);
}

export default memo(DonutChartWithText);
